export const TRIGGER_ACTION_LIST_PATH = "/settings-menu/trigger-action-list";

/** Правило, открытое на редактирование: адрес страницы ведёт и из таблицы, и из gateway. */
export const TRIGGER_ACTION_ID_PARAM = "triggerActionId";
